// THIS FILE IS USED TO GENERATE CHUNKS PER PAGE
// SO THAT SPA'S CAN LOAD THE NECESSARY CHUNKS PER PAGE
/* eslint-disable no-nested-ternary */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined';

// The keys of the object need to align with the PageKey type.
export const getRoutes = (currentRouteName, currentRouteComponent) => ({
  pojobnames: {
    name: 'pojobnames',
    componentName: 'PoJobNames',
    chunk: () =>
      import(
        /* webpackChunkName: "pojobnames" */
        './pages/PoJobNames'
      ),
    get component() {
      return ssr
        ? __webpack_require__(
            require.resolveWeak('@cwd/src/pages/PoJobNames.tsx'),
          ).PoJobNames
        : currentRouteName === 'pojobnames'
        ? currentRouteComponent
        : generateAsyncRoute(() =>
            this.chunk().then((pageModule) => ({
              default: pageModule.PoJobNames,
            })),
          );
    },
    path: '/:context?/myaccount/pojobnames',
    channel: null,
  },
  assignproallowance: {
    name: 'assignproallowance',
    componentName: 'AssignProAllowance',
    chunk: () =>
      import(
        /* webpackChunkName: "AssignProAllowance" */
        './pages/AssignProAllowance'
      ),
    get component() {
      return ssr
        ? __webpack_require__(
            require.resolveWeak('@cwd/src/pages/AssignProAllowance.tsx'),
          ).AssignProAllowance
        : currentRouteName === 'assignproallowance'
        ? currentRouteComponent
        : generateAsyncRoute(() =>
            this.chunk().then((pageModule) => ({
              default: pageModule.AssignProAllowance,
            })),
          );
    },
    path: '/:context?/myaccount/proallowance/assign',
    channel: null,
  },
  proallowance: {
    name: 'proallowance',
    componentName: 'ProAllowance',
    chunk: () =>
      import(
        /* webpackChunkName: "proallowance" */
        './pages/ProAllowance'
      ),
    get component() {
      return ssr
        ? __webpack_require__(
            require.resolveWeak('@cwd/src/pages/ProAllowance.tsx'),
          ).ProAllowance
        : currentRouteName === 'proallowance'
        ? currentRouteComponent
        : generateAsyncRoute(() =>
            this.chunk().then((pageModule) => ({
              default: pageModule.ProAllowance,
            })),
          );
    },
    path: '/:context?/myaccount/proallowance',
    channel: null,
  },
});
